import React from 'react'
import "./intro.css"

export default function Intro() {
  return (
    <section id='intro'>
         <div class="introContent">
        <h1 class="introTitle">
            DÉPANNAGE ET REMORQUAGE NANTES 44 <br/>24/7
        </h1>
        
        <div class="ContactBtnContent">
          <a href="tel:+33677068056" class="ContactBtn">
            06 77 06 80 56
          </a>
          
          <p><br /> Appels et devis GRATUITS 24H/24 et 7j/7</p>
        </div>
      </div>

    </section>
  )
}
